import React, { useEffect, memo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "../../../components/SideBar/SideBar2";
import { getLocalStorage } from "../../../components/Helper/Helper";
import RingLoader from "react-spinners/RingLoader";
import "../../../styles/admin.css";
import { createCompany } from "../UserManagement/actions";
import { connect } from "react-redux";
import { compose } from "redux";
import { getAllPartner, deactivateCompany, updateCompany, getAllGroupList, getRegionList, getDepartmentList } from "./actions";
import Company from "./Company";
import { Modal } from "react-responsive-modal";
import Register_Company from "../UserManagement/Form_Components";
import { TextField } from "@material-ui/core";
import EditCompanyProfile from "./EditCompanyProfile";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import FromToDatePicker from "../Component/fromAndToDate";
import ManageExcelExport from "../Component/excelExport";
import TopHeaderBar from "../Component/topHeaderBar";
import '../Component/table.css'
const ManagePartner = (props) => {
  const [companyModal, setcompanyModal] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setStatus] = useState("");
  const [deactivate, setDeactivate] = useState(false)
  const [fromDate, setFromDate] = useState()
  const [toDate, setToDate] = useState()

  useEffect(() => {
    props.getAllPartner();
    props.getAllGroupList();
    props.getRegionList();
    props.getDepartmentList();
  }, []);
  useEffect(() => {
    //search, page,fromDate,toDate,rowPerPageLimit,isDownload
    props.getAllPartner(searchVal, currentPage, fromDate, toDate, rowsPerPage, false,status);
  }, [deactivate, fromDate, toDate, rowsPerPage, currentPage, status, searchVal]);


  const [editUser, setEditUser] = useState({});
  const [editCompany, setEditCompany] = useState(false);



  const changeDisplay = (data) => {
    setcompanyModal(false);
  };
  const submitCompany = async (data, image) => {
    console.log("IMAGE: ", data, image);
    let data1 = {
      company: data.cname,
      panNumber: data.panNumber,
      company_address: data.company_address,
      rep_email: data.rep_email,
      rep_name: data.rep_name,
      isAuditClient: data.isAuditClient,
      image: image,
      group_id: data.group
    };
    let resp = await props.createCompany(data1);
    await props.getAllPartner();
    await props.getAllGroupList();
    console.log("data we got is" + JSON.stringify(resp));
    setcompanyModal(false);
    //  this.forceUpdate();

    //  await this.errorNot('Company Created Successfully')
  };
  const handleClearFilters = () => {
    setFromDate("")
    setToDate("")
    setRowsPerPage(10)
    setCurrentPage(1)
    setSearchVal("")
    setStatus("")
  }
  /* Update company details */
  const updateCompanyDetails = async (data) => {
    console.log("dataOfNames", data)
    let data1 = {
      id: data.id,
      partnerName: data.partnerName,
      partnerEmail: data.partnerEmail,
      department: data.department,
      region: data.region,
    };
    console.log("UpdatedCompanyData", data1);
    let resp = await props.updateCompany(data1);
    await props.getAllPartner();
    await props.getAllGroupList();
    console.log("data we got is" + JSON.stringify(resp));
    setEditCompany(false);
    //  this.forceUpdate();

    //  await this.errorNot('Company Created Successfully')
  };
  const deactivateCompanies = async (id) => {
    await props.deactivateCompany(id);
    await props.getAllPartner();
  };

  const openEditUserModal = (user) => {
    console.log("userDetails=>", user);
    setEditUser(user);
    // this.props.setEditUserModal(true);
    setEditCompany(true);
    console.log("EditCompaneyModel", editCompany);
  };

  const onEditCloseModal = () => {
    setEditCompany(false);
  };

  const onSearch = async (e) => {
    setSearchVal(e.target.value);
    await props.getAllPartner(e.target.value, 1);
  };
  const handleRowsPerPageChange = (currentPage, rowsPerPage) => {
    setRowsPerPage(rowsPerPage)
    setCurrentPage(currentPage)
  }
  return (
    <>
      <NavBar
        currentPage="Manage Partner"
        module="admin"
        userRole={getLocalStorage("role")}
      >
        <div className="sweet-loading">
          <RingLoader
            size={100}
            color={"#123abc"}
            loading={props.loaderStatus}
          />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <TopHeaderBar
          CurrentStatus={status}
          fromDate={fromDate}
          toDate={toDate}
          onSearch={onSearch}
          searchVal={searchVal}
          OnStatusValueChange={(value) => { setStatus(value) }}
          onDatePickerValueChange={(fromDate, toDate) => {
            setFromDate(fromDate)
            setToDate(toDate)
          }}
          onClearFilters={handleClearFilters}
          addBtnName={"Add Partner"}
          OnAddbtnClick={() => { setcompanyModal(true) }}
          onExport={() => {
            props.getAllPartner(searchVal, 0,fromDate,toDate, 100000, true);
          }}
        />

        <div>
          <Company

            data={props.companies}
            openEditUserModal={openEditUserModal}
            deactivate={deactivateCompanies}
            createCompany={props.createCompany}
            totalRecords={props.records}
            mainHandleRowsPerPageChange={handleRowsPerPageChange}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
          />
        </div>

        <Dialog
          aria-labelledby="customized-dialog-title"
          fullWidth={true}
          maxWidth="sm"
          open={editCompany}
          // onClose={onEditCloseModal}
        >
          <MuiDialogTitle
            disableTypography
            style={{ backgroundColor: "#4f2d7f", color: "white" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">{"Update Partner"}</Typography>
              <CloseIcon
                onClick={onEditCloseModal}
                color="white"
                style={{ cursor: "pointer" }}
              />
            </div>
          </MuiDialogTitle>
          <MuiDialogContent dividers>
            <div>
              <EditCompanyProfile
                onSubmit={updateCompanyDetails}
                groups={props.groups}
                EditUser={editUser}
                departmentList={props.departmentList}
                regionList={props.regionList}
              />
            </div>
          </MuiDialogContent>
        </Dialog>

        <Dialog
          aria-labelledby="customized-dialog-title"
          fullWidth={true}
          maxWidth="sm"
          open={companyModal}
          // onClose={changeDisplay}
        >
          <MuiDialogTitle
            disableTypography
            style={{ backgroundColor: "#4f2d7f", color: "white" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">{"Add New Partner"}</Typography>
              <CloseIcon
                onClick={changeDisplay}
                color="white"
                style={{ cursor: "pointer" }}
              />
            </div>
          </MuiDialogTitle>
          <MuiDialogContent dividers>
            <div>
              <EditCompanyProfile
                onSubmit={updateCompanyDetails}
                groups={props.groups}
                EditUser={{}}
                departmentList={props.departmentList}
                regionList={props.regionList}
              />
            </div>
          </MuiDialogContent>
        </Dialog>
      </NavBar>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loaderStatus: state.managePartnerReducer.loaderStatus,
    companies: state.managePartnerReducer.companies,
    totalRecords: state.managePartnerReducer.totalRecords,
    records: state.managePartnerReducer.records,
    groups: state.managePartnerReducer.groups,
    departmentList: state.managePartnerReducer.departmentList,
    regionList: state.managePartnerReducer.regionList
  };
};
export function mapDispatchToProps(dispatch) {
  return {
    getAllPartner: (search, page, fromDate, toDate, rowPerPageLimit, isDownload,status) => dispatch(getAllPartner(search, page, fromDate, toDate, rowPerPageLimit, isDownload,status)),
    deactivateCompany: (id) => dispatch(deactivateCompany(id)),
    createCompany: (data) => dispatch(createCompany(data)),
    updateCompany: (data) => dispatch(updateCompany(data)),
    getAllGroupList: () => dispatch(getAllGroupList()),
    getRegionList: () => dispatch(getRegionList()),
    getDepartmentList: () => dispatch(getDepartmentList())


  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(ManagePartner);
